// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-top {
  margin-top: 10px;
}

img {
    display: block;
}
textarea {
  resize: none;
  min-height: 200px;
}
.contact-us {
  height: calc(100vh - 50px);
  width: 100%;
  overflow:hidden;
}

.contact-us .contact-us-inner {
  width:100%;
  width: calc(100vh - 50px);
  height:100%;
  height: calc(100 - 10em);
  position: relative;
  display: inline-block;
}
.contact-us-item {
  height: 100%;
  overflow: hidden;
}
.contact-us-item .contact-us-img {
  height: 80%;
  min-height: 300px;
  opacity: 0.8;
  background: no-repeat center center scroll;
  background-size: cover;
}

.contact-us-caption {
  font-size: 70px;
  font-weight: bold;
  text-shadow: 1px 1px;
}
.main h1 {
  /*  position: absolute;
    top: 34%;
    left: 24.5%;
    */
    transform: translate( -50%, -50% );
    color: white;
}
.dig-trans-bkgd {
  filter: blur(2px);
  opacity: .6;
}


.dig-trans {
  bottom: 60%;
  right: 50%;
}


figure.overlay {
  position: relative;
  width: 100%;
  max-height: 100%;
  z-index: 1;
}
figure.overlay img {
  width: 100%;
  max-height: 620px;
  object-fit: cover;
}

figure.overlay figcaption {
  position: absolute;
  z-index: 1000;
  height: 100%;
  width: 100%;
  top: 13%;
  /**optional background overlay**/
/*  background: rgba(255,255,255,0.2); */
  /**text, adjust all values as desired**/
  padding: 0 0 40% 18%;
  font-weight: 700;
  color: white;
  /**some fallback value**/
  font-size: 20px;
  /**responsive size is roughly 3.4%  of the device's viewport width**/
  font-size: 7.5vw;
}


.blue-text {
  color: cornflowerblue;
  text-shadow: 2px, 2px , 10px, cornflowerblue ;
 }`, "",{"version":3,"sources":["webpack://./src/app/about/contact/contact.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,0CAA0C;EAI1C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;;;KAGG;IACD,kCAAkC;IAClC,YAAY;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,gCAAgC;AAClC,wCAAwC;EACtC,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,oEAAoE;EACpE,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;EACrB,6CAA6C;CAC9C","sourcesContent":[".not-top {\r\n  margin-top: 10px;\r\n}\r\n\r\nimg {\r\n    display: block;\r\n}\r\ntextarea {\r\n  resize: none;\r\n  min-height: 200px;\r\n}\r\n.contact-us {\r\n  height: calc(100vh - 50px);\r\n  width: 100%;\r\n  overflow:hidden;\r\n}\r\n\r\n.contact-us .contact-us-inner {\r\n  width:100%;\r\n  width: calc(100vh - 50px);\r\n  height:100%;\r\n  height: calc(100 - 10em);\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.contact-us-item {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n.contact-us-item .contact-us-img {\r\n  height: 80%;\r\n  min-height: 300px;\r\n  opacity: 0.8;\r\n  background: no-repeat center center scroll;\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n}\r\n\r\n.contact-us-caption {\r\n  font-size: 70px;\r\n  font-weight: bold;\r\n  text-shadow: 1px 1px;\r\n}\r\n.main h1 {\r\n  /*  position: absolute;\r\n    top: 34%;\r\n    left: 24.5%;\r\n    */\r\n    transform: translate( -50%, -50% );\r\n    color: white;\r\n}\r\n.dig-trans-bkgd {\r\n  filter: blur(2px);\r\n  opacity: .6;\r\n}\r\n\r\n\r\n.dig-trans {\r\n  bottom: 60%;\r\n  right: 50%;\r\n}\r\n\r\n\r\nfigure.overlay {\r\n  position: relative;\r\n  width: 100%;\r\n  max-height: 100%;\r\n  z-index: 1;\r\n}\r\nfigure.overlay img {\r\n  width: 100%;\r\n  max-height: 620px;\r\n  object-fit: cover;\r\n}\r\n\r\nfigure.overlay figcaption {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 13%;\r\n  /**optional background overlay**/\r\n/*  background: rgba(255,255,255,0.2); */\r\n  /**text, adjust all values as desired**/\r\n  padding: 0 0 40% 18%;\r\n  font-weight: 700;\r\n  color: white;\r\n  /**some fallback value**/\r\n  font-size: 20px;\r\n  /**responsive size is roughly 3.4%  of the device's viewport width**/\r\n  font-size: 7.5vw;\r\n}\r\n\r\n\r\n.blue-text {\r\n  color: cornflowerblue;\r\n  text-shadow: 2px, 2px , 10px, cornflowerblue ;\r\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
